import { render, staticRenderFns } from "./PrintClientAccount.vue?vue&type=template&id=74867c6c&"
import script from "./PrintClientAccount.vue?vue&type=script&lang=js&"
export * from "./PrintClientAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports